import { render } from "./ContratTable.vue?vue&type=template&id=6589fff1"
import script from "./ContratTable.vue?vue&type=script&lang=js"
export * from "./ContratTable.vue?vue&type=script&lang=js"

import "./ContratTable.vue?vue&type=style&index=0&id=6589fff1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__